export default __webpack_public_path__ + "static/media/electric-heater-gray.2a79a00c.svg";